<template>
  <div class="chart-block" style="padding-bottom: 24px">
    <h3>
      {{ chartName }}

      <span>{{ updated }}</span>
      <!-- <el-radio-group v-model="timeType" size="mini" class="opt" @change="bindChart()" :disable="loading"> -->
      <!-- <el-radio-button label="当月"></el-radio-button> -->
      <!-- <el-radio-button label="当月新能源"></el-radio-button> -->
      <!-- <el-radio-button label="当年"></el-radio-button> -->
      <!-- <el-radio-button label="当年新能源"></el-radio-button> -->
      <!-- </el-radio-group> -->
    </h3>
    <div id="chart_province" class="chart-box" loading></div>
  </div>
</template>
<script>
import echarts from "echarts";
import china from "echarts/map/json/china.json";
import { mapMutations, mapGetters, mapActions, mapState } from "vuex";
export default {
  props: {
    chartName: {
      type: String,
      default: "省份申请数分布",
    },
  },
  data() {
    return {
      loading: true,
      tip: "数据来源：知嘟嘟",
      chartId: "province_chart",
      chartOption: {},
      dataList: [],
      updated: "每月中旬更新",
      timeType: "当月",
      myChart: null,
      currentDate: "",
    };
  },
  mounted() {
    echarts.registerMap("china", china);

    this.chartOption = {
      tooltip: {
        formatter: function (params, ticket, callback) {
          return params.name + "<br /> 申请：" + params.value + " 件";
        },
      },
      visualMap: {
        min: 0,
        max: 60000,
        left: "6%",
        top: "bottom",
        text: ["高", "低"],
        inRange: {
          color: ["#d6e8f2", "#476a9d"],
        },
        show: false,
      },
      geo: {
        map: "china",
        roam: false,
        zoom: 1.23,
        label: {
          normal: {
            show: false,
            fontSize: "10",
            color: "rgba(0,0,0,0.7)",
          },
        },
        itemStyle: {
          normal: {
            borderColor: "rgba(255, 255, 255, 0.5)",
          },
          emphasis: {
            areaColor: "#F3B329",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            shadowBlur: 20,
            borderWidth: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
      series: {
        name: "信息量",
        type: "map",
        geoIndex: 0,
        data: [],
      },
    };

    this.queryWidgetByName({
      params: { name: "province" },
      handle: this.updateWidget,
    });
  },
  methods: {
    ...mapActions("widgets", ["queryWidgetByName"]),
    updateWidget(data) {
      this.myChart = echarts.init(document.getElementById("chart_province"));
      this.myChart.setOption(this.chartOption);
      window.addEventListener("resize", () => {
        this.myChart.resize();
      });
      this.dataList = data.jsonData; // eval("("+data.jsonData+")") ;
      this.loading = false;
      this.bindChart();
    },
    bindChart() {
      if (this.timeType == "当月") {
        this.chartOption.series.data = this.dataList.monthly;
      } else if (this.timeType == "当月新能源") {
        this.chartOption.series.data = this.dataList.monthly_ne;
      } else if (this.timeType == "当年") {
        this.chartOption.series.data = this.dataList.yearly;
      } else if (this.timeType == "当年新能源") {
        this.chartOption.series.data = this.dataList.yearly_ne;
      }

      this.myChart.setOption(this.chartOption);
    },
  },
  computed: {},
  watch: {},
  created() {},
};
</script>
<style scoped>
#chart_province {
  min-height: 300px;
  min-width: 300px;
}
</style>